<template>
  <div>Redirecting...</div>
</template>

<script>

/** Use this simple component for routes that should be handled with v3.
 *
 * It simply rewrites current hash path to a pathname, so `/#/dashboard/v3` gets transformed to `/dashboard/v3`.
*/
export default {
  name: 'RedirectToV3',
  mounted() {
    const newUrl = new URL(window.location.href);
    newUrl.pathname = newUrl.hash.replace('#', '');
    newUrl.hash = '';

    const v3Url = newUrl.toString();
    console.warn('Redirecting to v3..,', v3Url);
    window.location.replace(v3Url);
  }
};

</script>
